import { useQueryClient } from "@tanstack/react-query";

import { useUpdateOrgReportingEnabled } from "@/apiQueries/useUpdateOrgReportingEnabled";

import { useRedux } from "@/hooks/useRedux";
import { useSettingsToggle } from "@/hooks/useSettingsToggle";

import { CardWithToggler } from "./CardWithToggler";

export const SettingsEnableReporting = () => {
  const { organization } = useRedux("organization");
  const queryClient = useQueryClient();

  const { isChecked, isPending, error, handleToggleChange } = useSettingsToggle({
    currentValue: Boolean(organization.data.reporting_enabled),
    useUpdateMutation: useUpdateOrgReportingEnabled,
    getNextValue: (current) => !current,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["appConfig"] });
    },
  });

  return (
    <CardWithToggler
      toggleId="reporting-enabled"
      label="Enable Reports"
      note="Toggle this option to enable the Reports page for this organization. When enabled, users can download wallet statements and individual transaction notices as PDFs."
      isChecked={isChecked}
      isPending={isPending}
      error={error}
      onToggleChange={handleToggleChange}
    />
  );
};
